module.exports = __webpack_public_path__ + "static/media/instagram-round-link.4b605009.png";